
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/animations/globalAnimationsPanel/globalAnimations.scss.css.virtualfile';
        module.exports = {"animationKitsList":"_animationKitsList_1ny4z_1","animationKitButton":"_animationKitButton_1ny4z_5"};